import React from 'react'
import Seo from "../components/seo"
import Layout from "../components/layout"
import { usePageMetadata } from "../hooks/usePageMetadata"

const NotFoundPage = () => {
  usePageMetadata({
    title: '404 - Page Not Found',
    description: 'The page you are looking for could not be found.',
    pageType: 'error',
    content: {
      page: {
        name: "404 Not Found",
        error_code: "404",
        message: "Oops… seems like you got lost in space. The page you're looking for doesn't exist."
      },
      suggestions: [
        "Go back to the homepage",
        "Check the URL for typos",
        "Use the navigation menu",
        "Contact us if you need help"
      ],
      meta: {
        source_url: "https://bercastle.com/404",
        page_type: "error"
      }
    }
  });

  return(
    <Layout classmain='none'>
      <Seo title="404" description="Something is not right with this webpage, please try again or go try a different webpage." />

      <div className='flex flex-col justify-center items-center min-h-screen text-center px-4'>
        <div className='mb-8'>
        </div>
        <h2 className='text-6xl font-bold mb-4'>404</h2>

        <p className='text-xl mb-8'>Oops… seems like you got lost in space</p>
        <div className=''>
          <a className="px-6 py-2 border border-black bg-white text-black font-bold uppercase inline-flex items-center gap-2.5 transition-all hover:bg-brand-beige" href="/">
              Homepage
          </a>
        </div>
      </div>
    </Layout>
  )
}

export default NotFoundPage
